import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import '../css/management.css';
import { Link, useLocation } from 'react-router-dom';
import helpers from '../helper';
import axios from 'axios';
import ContentLoader from 'react-content-loader';

export default function Management({ type = 'board' }) {
    const isBoard = type === 'board';
    const pageTitle = isBoard ? 'Board of Directors' : 'Leadership Team';
    const [board, setBoard] = useState([]);
    const [leadership, setLeadership] = useState([]);
    const [pageloader, setPageloader] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setPageloader(true);
        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/managementteam')
                .then((response) => {
                    setBoard(response.data.result.board);
                    setLeadership(response.data.result.leadership);
                    setPageloader(false);
                });
        }
        fetchData();
    }, [setBoard, setLeadership]);

    useEffect(() => {
        if (!pageloader && location.hash) {
            const el = document.getElementById(location.hash.replace('#', ''));
            if (el) {
                setTimeout(() => { el.scrollIntoView({ behavior: 'smooth' }); }, 100);
            }
        }
    }, [location, pageloader]);

    const memberImage = (member) => (
        helpers.helpers1(member.image) ?
            <picture className="img">
                <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/management/' + member.image} alt={member.name} className="w-100" width="400" height="400" />
            </picture>
            :
            <picture className="img">
                <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/management/webp/' + member.image + '.webp'} type="image/webp" />
                <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/management/jpg/' + member.image + '.jpg'} alt={member.name} className="w-100" width="400" height="400" />
            </picture>
    );

    return (
        <>
            <Helmet>
                <title>{pageTitle} : PES Installations Limited</title>
                <meta name="description" content={pageTitle + ' of PES Installations Limited'} />
            </Helmet>
            <main className='Sec5'>
                <section className="InnerHead bgthm2">
                    <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="Management Team" className="imgbg" width="1600" height="453" />
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8 text-center">
                                <h1 className="fw-normal text-white">{pageTitle}</h1>
                                <ol className="breadcrumb m-0 justify-content-center">
                                    <li className="breadcrumb-item"><Link to="/"><img src={require("../assets/img/home.svg").default} width="14" height="14" alt="Home" /></Link></li>
                                    <li className="breadcrumb-item"><span aria-current="page">{pageTitle}</span></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="TeamSec">
                    <div className="container">
                        {
                            pageloader ?
                                <ContentLoader height={400} width={1660} backgroundColor="#f5f5f5" foregroundColor="#dbdbdb">
                                    <rect x="30" y="20" rx="8" width="280" height="330" />
                                    <rect x="340" y="20" rx="8" width="280" height="330" />
                                    <rect x="650" y="20" rx="8" width="280" height="330" />
                                    <rect x="960" y="20" rx="8" width="280" height="330" />
                                </ContentLoader>
                                :
                                <>
                                    {
                                        isBoard && board.length > 0 ?
                                            <div className="TeamBlock" id="board-of-directors">
                                                <div className="text-center mb-4">
                                                    <h2>Board of Directors</h2>
                                                    <p className="text-muted">Meet the minds driving our mission</p>
                                                </div>
                                                <div className="row justify-content-center">
                                                    {
                                                        board.map((member, m) =>
                                                            <div key={m} className="col-lg-3 col-md-4 col-sm-6 mb-4">
                                                                <div className="TeamCard text-center">
                                                                    {memberImage(member)}
                                                                    <h3 className="h5 mt-3 mb-1">{member.name}</h3>
                                                                    <small className="text-muted d-block mb-2">{member.designation}</small>
                                                                    <Link to={"/board-of-directors/" + member.alias} className="ReadMore" title={member.name}>Read More</Link>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            : ''
                                    }
                                    {
                                        !isBoard && leadership.length === 0 ?
                                            <div className="text-center py-5">
                                                <p className="text-muted m-0">Leadership team details will be published shortly.</p>
                                            </div>
                                            : ''
                                    }
                                    {
                                        !isBoard && leadership.length > 0 ?
                                            <div className="TeamBlock" id="leadership-team">
                                                <div className="text-center mb-4 mt-5">
                                                    <h2>Leadership Team</h2>
                                                    <p className="text-muted">Visionaries leading with purpose and precision</p>
                                                </div>
                                                <div className="row justify-content-center">
                                                    {
                                                        leadership.map((member, m) =>
                                                            <div key={m} className="col-lg-3 col-md-4 col-sm-6 mb-4">
                                                                <div className="TeamCard text-center">
                                                                    {memberImage(member)}
                                                                    <h3 className="h5 mt-3 mb-1">{member.name}</h3>
                                                                    <small className="text-muted d-block">{member.designation}</small>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            : ''
                                    }
                                </>
                        }
                    </div>
                </section>
            </main>
        </>
    )
}
